// App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from './app/auth/login/login';
import Dashboard from './app/pages/dashboard/dashboard';
import PageNotFound from './app/components/not-found';
import { Authentication } from './service/auth.utils';
import MiniDrawer from './app/pages/layout';
import UserType from './app/pages/userManagement/userType/userType'
import ProtectedRoute from './middleware'
import ForgotPassword from './app/auth/forgotPassword/forgotPassword';
import UserTypeCreation from './app/pages/userManagement/userType/addUserType/addUserType';
import UserTypeView from './app/pages/userManagement/userType/userTypeView/userTypeView.page'
import User from './app/pages/userManagement/user/user';
import SubscriptionPlans from './app/pages/licenseManagement/subscriptionPlans/subscriptionPlans';
import SubcriptionsCreation from './app/pages/licenseManagement/subscriptionPlans/addSubcriptions/addSubcriptions';
import Initiative from './app/pages/solutionManagement/initiative/initiative';
import InitiativeCreation from './app/pages/solutionManagement/initiative/addInitiative/addInitiative';
import InitiativeView from './app/pages/solutionManagement/initiative/initiativeView/initiativeView';
import SubscriptionView from './app/pages/licenseManagement/subscriptionPlans/subscriptionView/subscriptionView';
import UserView from './app/pages/userManagement/user/userView/userView';
import UserProfile from './app/pages/userProfile/userProfile';
import SolutionManagementTable from './app/pages/solutionManagement/initiative/solutionManagement';
import CountryManagement from './app/pages/countryManagement/countryManagement';
import CountryManagementCreation from './app/pages/countryManagement/countryManagementCreation/countryManagementCreation';
import CountryManagementView from './app/pages/countryManagement/countryManagementView/countryManagementView';
import EcosystemPartners from './app/pages/ecosystemPartners/ecosystemPartners';
import { EcosystemPartnersCreation } from './app/pages/ecosystemPartners/ecosystemPartnersCreation/ecosystemPartnersCreation';
import EcosystemPartnersView from './app/pages/ecosystemPartners/ecosystemPartnersView/ecosystemPartnersView';

if (process.env.NODE_ENV !== 'test') {
  import('./App.css');
}

  export const App = () => {
  const tokenAuthentication = new Authentication();
  const isAuthenticated = tokenAuthentication.isAuthenticated();

  return (
    <>

    <Router future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
      <Routes>
        <Route path="/" element={isAuthenticated ? (<Navigate to="/subscriptionPlans" replace />) : (<Navigate to="/auth/login" replace />)} />
        <Route path="/auth/login" element={isAuthenticated ? (<Navigate to="/subscriptionPlans" replace />) : (<Login />)} />
        <Route path="/auth/forgotPassword" element={isAuthenticated ? (<Navigate to="/subscriptionPlans" replace />) : (<ForgotPassword />)} />

        <Route element={<ProtectedRoute/>}>
          <Route element={<MiniDrawer />}>

            <Route path="/dashboard" element={<Dashboard />} />

            <Route path="/userProfile" element={<UserProfile />} />

            <Route path="/userType" element={<UserType />} />
            <Route path="/addUserType" element={<UserTypeCreation />} />
            <Route path="/userTypeView/:id" element={<UserTypeView />} />
            <Route path="/addUserType/:id" element={<UserTypeCreation />} />

            <Route path="/user" element={<User />} />
            <Route path="/userView/:id" element={<UserView />} />

            <Route path="/subscriptionPlans" element={<SubscriptionPlans />} />
            <Route path="/addSubcriptions" element={<SubcriptionsCreation />} />
            <Route path="/subscriptionView/:id" element={<SubscriptionView />} />
            <Route path="/addSubcriptions/:id" element={<SubcriptionsCreation />} />

            <Route path="/initiative" element={<Initiative />} />
            <Route path="/solutionManagement" element={<SolutionManagementTable />} />
            <Route path="/addInitiative" element={<InitiativeCreation />} />
            <Route path="/initiativeView/:id" element={<InitiativeView />} />
            <Route path="/addInitiative/:id" element={<InitiativeCreation />} />

            <Route path="/countryManagement" element={<CountryManagement />} />
            <Route path="/countryManagementCreation" element={<CountryManagementCreation />} />
            <Route path="/countryManagementView/:id" element={<CountryManagementView />} />
            <Route path="/countryManagementCreation/:id" element={<CountryManagementCreation />} />

            <Route path="/ecosystemPartners" element={<EcosystemPartners />} />
            <Route path="/ecosystemPartnersCreation" element={<EcosystemPartnersCreation />} />
            <Route path="/ecosystemPartnersView/:id" element={<EcosystemPartnersView />} />
            <Route path="/ecosystemPartnersCreation/:id" element={<EcosystemPartnersCreation />} />

          </Route>
        </Route>

        <Route path="*" element={isAuthenticated ? <PageNotFound /> : <Navigate to="/auth/login" replace />} />
      </Routes>
    </Router>
    </>
  );
}

